export default __webpack_public_path__ + "static/media/users-list.e4a4a285.jpg";